import type { EditorState } from '#packages/stateManagement';

const getCurrentBranchName = (state: EditorState): string =>
  state.branches.currentBranchName;

const getWasBranchesListFetched = (state: EditorState): boolean =>
  state.branches.wasBranchesListFetched;

const getHasBranches = (state: EditorState): boolean =>
  !!state.branches.hasBranches;

const getDsHasBranches = (state: EditorState): boolean => {
  const branchesList = state.branches.dsBranchesList;
  return branchesList?.length > 1;
};

export {
  getCurrentBranchName,
  getWasBranchesListFetched,
  getHasBranches,
  getDsHasBranches,
};
